// Light-background palette for /event-trace-light. Everything not overridden
// here is re-exported unchanged from ./topology, which this file only reads.
export {
  KNOWN_DEVICES, EDGE_AGENT_IP, EDGE_AGENT_NAME, fmtUtc,
  POLICY_PLAIN_NAMES, plainPolicyName, SITE_NATIVE_PREFIX, SUBSTATION_IPS,
} from './topology';

// The dark page's 400/500 shades wash out on white; these are the 600/700 shades.
export const PROTOCOL_COLORS = {
  dnp3:    '#2563EB',  // blue
  mms:     '#0D9488',  // teal
  goose:   '#CA8A04',  // gold
  modbus:  '#059669',  // green
  snmp:    '#7C3AED',  // purple
  bacnet:  '#EA580C',  // orange
  it:      '#DC2626',  // red
};

export const ROLE_COLORS = {
  PLC:       '#0891B2',  // cyan
  IED:       '#4F46E5',  // indigo
  HMI:       '#DB2777',  // pink
  Historian: '#65A30D',  // lime
  Gateway:   '#EA580C',  // orange
  RTU:       '#059669',  // emerald
  // Role classes used only by the display-only device types (./deviceTypes.js).
  ProtectionRelay:   '#4F46E5',  // indigo, as IED
  SubstationGateway: '#EA580C',  // orange, as Gateway
};

export const SEVERITY_COLORS = {
  Critical:      '#DC2626',
  High:          '#EA580C',
  Medium:        '#CA8A04',
  Low:           '#64748B',
  Informational: '#475569',
};
